import React, { useContext, useEffect } from "react";
import MassageItem from "./MassageItem";
import AddonItem from "./AddonItem";
import WaxItem from "./WaxItem";
import { ServiceContext } from "../../context/Contexts";
import "../../css/Services.css";
import { Helmet } from "react-helmet";

export const Services = () => {
  const serviceContext = useContext(ServiceContext);
  const { services, loadServices, addons, loadAddons, waxes, loadWaxes } =
    serviceContext;

  useEffect(() => {
    // Load services, addons, and waxes when the component mounts
    loadServices();
    loadAddons();
    loadWaxes();
    // eslint-disable-next-line
  }, []); // Empty dependency array to run only once

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <div className="services-page">
      <Helmet>
        <title>Massages</title>
        <link
          rel="canonical"
          href="https://touch-massagetherapy.com/services"
        />
      </Helmet>
      <div className="center-text">
        <ul className="service-nav">
          <li>
            <a href="#massages">Massages</a>
          </li>
          <li>
            <a href="#addons">Addons</a>
          </li>
          <li>
            <a href="#wax">Waxing</a>
          </li>
          <li>
            <a href="#facial">Facial</a>
          </li>
        </ul>
      </div>
      <section id="massages">
        <h1 className="center-text glow fancy-font big-text-2">Massages</h1>
        <p className="center-text bold callout">
          *Add an additional 15 minutes: $23.50 Couples: $47{" "}
        </p>

        <div className="services-container">
          <a
            href={require("../../brochure/brochure.pdf")}
            download="Services-Brochure.pdf"
            className="brochure-link"
            style={{
              fontSize: "20px",
              color: "var(--theme-secondary-light)",
              textDecoration: "underline",
            }}
          >
            Download Our Services Brochure (PDF)
          </a>
          {services
            .sort((a, b) => (a.title > b.title ? 1 : -1)) // Sort services by title
            .map((item) => (
              <MassageItem key={item.id} item={item} />
            ))}
        </div>
      </section>
      <section id="addons">
        <h1 className="center-text glow fancy-font big-text-2">Addons</h1>

        <div className="services-container">
          {addons
            .sort((a, b) => (a.title > b.title ? 1 : -1)) // Sort services by title
            .map((item) => (
              <AddonItem key={item.id} item={item} />
            ))}
        </div>
      </section>
      <section id="wax">
        <h1 className="center-text glow fancy-font big-text-2">Waxing</h1>

        <div className="services-container">
          {waxes
            .sort((a, b) => (a.title > b.title ? 1 : -1)) // Sort waxes by title
            .map((item) => (
              <WaxItem key={item.title} item={item} />
            ))}
        </div>
      </section>
      <section id="facial">
        <div className="container">
          <h1 className="fancy-font center-text glow big-text-2">
            Honey Glow Facial
          </h1>
          <br />
          <h2>$75 | 30 minutes</h2>
          <p>
            Glow from within with our Honey Glow Facial, designed to rejuvenate
            and nourish all skin types. This holistic treatment uses premium
            natural ingredients to cleanse, exfoliate, and restore your skin’s
            radiance. Enjoy a double cleanse, Manuka honey exfoliation, a
            detoxifying tulsi mask, and deeply hydrating moisturizers for a
            quick refresh and a glowing complexion.
          </p>
          <br />
          <h2>Massage + Honey Glow Facial Packages</h2>
          <br />
          <ul>
            <li>
              <h4>90 Minutes Total | $165</h4>
              <p>
                Enjoy a 60-minute therapeutic massage tailored to your needs,
                followed by a 30-minute Honey Glow Facial to leave your body
                relaxed and your skin glowing.
              </p>
            </li>
            <li>
              <h4>120 Minutes Total | $210</h4>
              <p>
                Combine a 90-minute therapeutic massage for full-body tension
                relief with our 30-minute Honey Glow Facial for the ultimate
                self-care experience.
              </p>
            </li>
            <li>
              <h4>150 Minutes Total | $255</h4>
              <p>
                Indulge in a 120-minute therapeutic massage for deep relaxation
                and rejuvenation, paired with our luxurious 30-minute Honey Glow
                Facial to refresh and hydrate your skin.
              </p>
            </li>
          </ul>
        </div>
      </section>
      <br />

      {/* Button to return to top */}
      <button className="to-top" onClick={scrollToTop}>
        <i class="fa-solid fa-arrow-up"></i>
      </button>
    </div>
  );
};

export default Services;
